module.exports = __webpack_public_path__ + "img/hypatiatalks.94cc0898.jpg";